const config = {
  // apiUrl: "https://apiblog.benito.dev",
  apiUrl: "https://apiblog.benito.dev",
};

export default config;
